<template>
  <v-container px-10 fluid>

    <v-row>
      <v-col md="8" mb-5 class="text-left">

        <v-card>
          <v-card-title class="blue lighten-2 text-h5">{{ title }}</v-card-title>
              <v-container
                 id="scroll-target"
                 style="min-height: 350px"
                 class="overflow-y-auto"
                 >

        <v-card-text v-if="page == 1.5">
        <h2><CENTER><FONT COLOR="BLUE">Request an Invitation to the<br>2025 Sky Farm Music & Arts Festival</FONT></CENTER></h2>

        <p>
            The Sky Farm Music & Arts festival is going to be one of the largest events Sky Farm has ever held.  A number of
            bands and performers will be there to provide live music throughout the day.  There will be a variety of artists
            there to show off their creative side, and of course plenty of food.  If you are invited to join us you will also
            be able to enjoy the regular benefits of the Farm including the pool, sunning lawns, tennis courts, hot tub and more.
        </p>

        <p>
            Sky Farm is a members only cooperative, so to attend the festival you either have to be a member, a guest of a
            current member or a guest of the membership team.  To get an invitation from the membership team to be their guest 
            for this amazing event please fill out the form on the following pages to be considered for membership.  The membership 
            team will review your request and if approved, you will be sent an invitation to this event.
        </p>
        <p>
            To help make sure Sky Farm is the right place for you, be
            sure to read our <a href="#/faq" >FAQ</a>.  Sky Farm is a family oriented nudist
            club and observes <a href="https://www.skyfarm.com/Images/SF-Logo.png">AANR Standards and Principles</a>.
        </p>

        </v-card-text>
        <v-card-text v-if="page == 1">

        <h2><CENTER><FONT COLOR="BLUE">Sign up For a Tour of Sky Farm</FONT></CENTER></h2>

        <p><center><b>Come on out and see why we think Sky Farm is the best place under the sun!</b></center></p>

        <p>While we are open year round, Sky Farm is an all volunteer
           cooperative and as our season is pretty much over there are
           not as many members around to give tours.  You are welcome
           to submit a tour request now and you will be added to the
           waiting list.  Tours will ramp up again in the Spring.
        </p>

        <p>To help make sure Sky Farm is the right place for you, be
           sure to read our <a href="#/faq" >FAQ</a>.  Sky Farm is a family oriented nudist
           club and observes <a href="https://www.skyfarm.com/Images/SF-Logo.png">AANR Standards and Principles</a>.</p>

        <p>Our Membership team would love to have the opportunity to
           tell you more about Sky Farm, show you around the grounds
           and answer any questions you might have. Please take a
           moment to fill out the following information and tell us
           something about yourself and a member of the membership
           committee will contact you when tours resume..</p>

        <p class="red--text"><B>NOTE:</B> To qualify for a tour and be considered for
           membership prospective members must pass a background
           check.  By submitting this request you are agreeing to
           having a background check performed.  <b><i>All information submitted will be kept in strict confidence.</i></b></p>

        </v-card-text>

        <v-card-text v-if="page == 6">

          <p>{{ message }}</p>

          <p>Thank you for the tour request!  We are absolutly sure you will love Sky Farm.  What they say is true, nudists absolutely see more of their friends!</p>

          <p v-if="values[2]['STATUS'] == 'Single' && values[2]['GENDER'] == 'Male'">Our waiting list is already quite long this season so it may take some time to hear from us.</p>

          <p>Please be patient, our membership team will contact you as soon as they have reviewed your request.  If you have any questions email <a href="mailto:membership@skyfarm.com">membership@skyfarm.com</a>.</p>

        </v-card-text>

        <div v-for="(pg,p) in form" :key="Object.keys(pg)[0]" width="100%" v-else>
          <v-form
             v-model="valid"
             method="post"
             :id="p"
             ref="national"
             >

          <v-card-text v-if="page == p">
            <v-row v-for="(row) in pg" :key="row">
                <v-col class="py-0" :cols="getSize(col)" v-for="(col,c) in row" :key="col">
                  <h3 class="pb-2" v-if="c == 'label'">{{ col.title }}</h3>
                  <p v-if="c == 'note'">{{ col.note }}</p>
                  <v-text-field class="pa-0"
                                v-if="getType(col)"
                                :readonly="col.readonly || false"
                                v-model=values[page][c]
                                :label=col.label
                                :type=col.type
                                :rules=col.rules
                                :hint=col.hint

                                validate-on="blur"
                                />
<!--
                  <v-radio-group
                     v-if="col.type == 'radio'"
                     v-model=values[page][c]
                     :rules=col.rules
                     row
                     >
                    <B>{{col.title}}</B>
                    <v-radio
                       v-for="(opt, j) in col.options"
                       :ref=values[page][c]
                       :key=j
                       :label=opt
                       :value=opt
                       ><template v-slot:label>{{col.labels[j]}}</template></v-radio>
                  </v-radio-group>
-->

                  <template v-if="col.type == 'menu'">
                    <v-select
                       v-model=values[page][c]
                       :items="col.options"
                       :rules=col.rules
                       :label="col.label"
                       ></v-select>
                  </template>

                  
                </v-col>
            </v-row>
          </v-card-text>
        </v-form>
        </div>

        </v-container>
          <v-card-actions class="blue lighten-2" v-if="page < 6">
              <v-spacer></v-spacer>
              <v-btn color="primary" @click="nextPage()" :disabled="!valid || submitting" :loading="submitting" class="ml-4" ><span v-if="valid">{{ nextLabel() }}</span><span v-else>Complete All Fields</span></v-btn>

          </v-card-actions>
        </v-card>

      </v-col>
      <v-col md=4>
        <center>
          <img height="250" :src="logo"/>
        </center>

        <p>To help make sure Sky Farm is the right place for you, be
           sure to read our <a href="#/faq" >FAQ</a>.  Sky Farm is a family oriented nudist
           club and observes <a href="https://www.aanr.com/about-aanr/">AANR Standards and Principles</a>.</p>

          <v-row class="text-center">
            <v-col class="mb-2" md="6">
              <v-card class="center ma-3" height="60" href="https://www.aanr.com" target="_blank">
              <v-img
                 src="/assets/AANR.jpg"
                 contain
                 height="60"/>
              </v-card>
            </v-col>

            <v-col class="mb-2" md="6">
              <v-card class="text-center ma-3" height="60" href="https://naturistsociety.com/" target="_blank">
              <v-img
                 src="/assets/n_logo.png"
                 contain
                 height="60"/>
              </v-card>
            </v-col>

          </v-row>

      </v-col>
    </v-row>

  </v-container>
</template>

<script>

import jsonp from 'jsonp-modernized'

var rules = {
    tel:  v => (v.length == 3) || '3 Digits Only',
    tel4: v => (v.length == 4) || '4 Digits Only',
    //shortText: v => (v.length <= 20) || 'Value must be less than 20 characters',
    shortText: v=> ( v.length <= 20) || "Value must be less than 20 characters." ,
    longText:  v => (v.length <= 60)  || 'Value must be less than 60 characters' ,
    email: v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
    required: v => !!v || 'required',
}

export default {
    data: () => ({
        values: [{},{},{},{},{},{},{}],
        texttypes: { text: 1, tel: 1, email: 1, number: 1},
        page: 1,
        valid: true,
        submitting: false,
        logo: "/Images/SF-Logo.png",
        festival: "/Images/SF%20Music%20&%20Arts%20Festival%20flyer_card%202.jpg",
        source: "Website",
        title: "Sky Farm Tour Request",
        message: "",
        form: {
            1: [],
            2: [
                { label: { title: "Your information" }},
                { note:  { note: "If you are interested in a couple or family membership, fill in your partner's information on the next screen." }},
                {  
                   FNAME: {
                        value: '',
                        label: 'First and Last Name',
                        type: 'text',
                        rules: [rules.shortText, rules.required],
                        hint: 'This is your full name, if you have a partner that will be collected later.',
                        fn: 1,
                   }
                },
                {
                    EMAIL: {
                        value: '',
                        label: 'Email',
                        type: 'text',
                        rules: [rules.email, rules.required],
                        size: 6,
                        fn: 0,
                    },
                    DOB1: {
                        value: '',
                        label: "Date of Birth",
                        type: 'text',
                        rules: [rules.shortText, rules.required],
                        hint: 'MM/DD/YYYY',
                        indent: true,
                        size: 6,
                        fn: 13,
                    }
                },
                
            {
                'ADDRESS[addr1]': {
                    value: '',
                    label: 'Street Address',
                    type: 'text',
                    rules: [rules.shortText, rules.required],
                    title: 'Home Address',
                    fn: "3[addr1]",

                }
            },
            {
                'ADDRESS[city]': {
                    value: '',
                    label: 'City',
                    type: 'text',
                    rules: [rules.required],
                    size: 5,
                    fn: "3[city]",
                },
                'ADDRESS[state]': {
                    value: '',
                    label: 'State',
                    hint: '2 Letter Code',
                    type: 'text',
                    rules: [rules.required],
                    size: 2,
                    len: 2,
                    next: 'ADDRESS[zip]',
                    fn: "3[state]",
                },
                'ADDRESS[zip]': {
                    value: '',
                    label: 'ZIP Code',
                    type: 'text',
                    rules: [rules.required],
                    size: 3,
                    len: 5,
                    next: 'PHONE[area]',
                    fn: "3[zip]",
                },
            },
            {
                label: { title: 'Phone:', size: 3 },
                'PHONE[area]': {
                    size: 2,
                    value: '',
                    label: '###', hint: 'Area Code',
                    type: 'text',
                    rules: [rules.required,rules.tel],
                    len: 3,
                    next: 'PHONE[detail1]',
                    fn: "4[area]",
                },
                'PHONE[detail1]': {
                    value: '',
                    label: '###',
                    size: 2,
                    type: 'text',
                    rules: [rules.required,rules.tel],
                    len: 3,
                    next: 'PHONE[detail2]',
                    fn: "4[detail1]",
                },
                'PHONE[detail2]': {
                    value: '',
                    size: 4,
                    label: '####',
                    type: 'text',
                    rules: [rules.required,rules.tel4],
                    fn: "4[detail2]",
                },
            },
            {
                GENDER: {
                    label: 'Gender',
                    value: '', size: 6,
                    type: 'menu',
                    options: ['Male','Female','Decline to Answer'],
                    labels: ['Male','Female','Decline to Answer'],
                    rules: [rules.required],
                    fn: 5,
                },
                STATUS: {
                    label: 'Marital Status',
                    value: '', size: 6,
                    type: 'menu',
                    options: ['Married','Partnered','Single'],
                    labels: ['Married','Partnered','Single'],
                    rules: [rules.required],
                    fn: 11,
                },
            },

                
            ],
            3: [
                { label: { title: "Your Partner's information" }},
                { note:  { note:  "This is required even for those looking for a single membership." }},
                {
                   FNAME: {
                       value: '',
                       label: 'First and Last Name',
                       type: 'text',
                       rules: [rules.shortText, rules.required],
                       hint: 'This is your full name, if you have a partner that will be collected later.',
                       fn: 2,
                   }
                },
                {
                    EMAIL: {
                        value: '',
                        label: 'Email',
                        type: 'text',
                        rules: [rules.email, rules.required],
                        size: 6,
                        fn: 12,
                    },
                    DOB1: {
                        value: '',
                        label: "Date of Birth",
                        type: 'text',
                        rules: [rules.shortText, rules.required],
                        hint: 'MM/DD/YYYY',
                        indent: true,
                        size: 6,
                        fn: 14,
                    }
                },
                
            {
                'ADDRESS[addr1]': {
                    value: '',
                    label: 'Street Address',
                    type: 'text',
                    rules: [rules.shortText, rules.required],
                    title: 'Home Address',
                    fn: "17[addr1]",
                }
            },
            {
                'ADDRESS[city]': {
                    value: '',
                    label: 'City',
                    type: 'text',
                    rules: [rules.required],
                    size: 5,
                    fn: "17[city]",
                },
                'ADDRESS[state]': {
                    value: '',
                    label: 'State',
                    hint: '2 Letter Code',
                    type: 'text',
                    rules: [rules.required],
                    size: 2,
                    len: 2,
                    next: 'ADDRESS[zip]',
                    fn: "17[state]",
                },
                'ADDRESS[zip]': {
                    value: '',
                    label: 'ZIP Code',
                    type: 'text',
                    rules: [rules.required],
                    size: 3,
                    len: 5,
                    next: 'PHONE[area]',
                    fn: "17[zip]",
                },
            },
            {
                label: { title: 'Phone:', size: 3 },
                'PHONE[area]': {
                    size: 2,
                    value: '',
                    label: '###', hint: 'Area Code',
                    type: 'text',
                    rules: [rules.required,rules.tel],
                    len: 3,
                    next: 'PHONE[detail1]',
                    fn: "18[area]",
                },
                'PHONE[detail1]': {
                    value: '',
                    label: '###',
                    size: 2,
                    type: 'text',
                    rules: [rules.required,rules.tel],
                    len: 3,
                    next: 'PHONE[detail2]',
                    fn: "18[detail1]",
                },
                'PHONE[detail2]': {
                    value: '',
                    size: 4,
                    label: '####',
                    type: 'text',
                    rules: [rules.required,rules.tel4],
                    fn: "18[detail2]",
                },
            },
            {
                GENDER: {
                    label: 'Gender',
                    value: '', size: 6,
                    type: 'menu',
                    options: ['Male','Female','Decline to Answer'],
                    labels: ['Male','Female','Decline to Answer'],
                    rules: [rules.required],
                    fn: "6",
                },
            },
            ],
            4: [
                { label: { title: "A little more information to help us know more about you."}},
                {
                    MTYPE: {
                        label: 'Membership Type Requested',
                        value: '', size: 6,
                        type: 'menu',
                        options: ['Single','Couple','Family'],
                        labels: ['Single','Couple','Family'],
                        rules: [rules.required],
                        fn: 7,
                    },
                },
                {
                   label: { title: "Why we should consider you for membership?  How did you hear about us?  If a Sky Farm member referred you let us know who they are." },
                },
                {
                    LEARN: {
                        label: 'Take your time and provide a thoughtful answer.',
                        value: '',
                        size: 12,
                        type: 'text',
                        rules: [rules.required],
                        fn: 8,
                    }
                },
                {   label: { title: 'For the following question, nudist clubs are those that practice family oriented nude recreation and are most likely part of AANR and/or The Naturist Society Network.' } },
                {
                    OTHER: {
                        label: 'What other nudist clubs have you visited if any?',
                        value: '',
                        size: 12,
                        type: 'text',
                        rules: [rules.required],
                        fn: 9,

                    }
                },
                {   label: { title: 'If you are an AANR member, please enter your membership number below.  Otherwise leave this empty.' }},
                {
                    AANR: {
                        label: 'AANR Membership Number',
                        value: '',
                        size: 6,
                        type: 'text',
                        fn: 10,
                    }
                }
            ],
            5: [
                { label: { title: 'Background Check Confirmation'}},
                { note: { note: 'A Background check is required for all prospective members.  By selecting agree and submitting this form you are allowing Sky Farm to perform a background check before a tour is scheduled.  Sky Farm reserves the right to decide whether or not to proceed with consideration for a tour and/or membership based on the results of the background check.' }},
                {
                    AGREE: {
                        label: 'Select AGREE to confirm',
                        value: '', size: 6,
                        type: 'menu',
                        options: ['AGREE'],
                        labels: ['AGREE'],
                        rules: [rules.required],
                        fn: 19,
                    },
                }
            ]

        },
        action: 'https://skyfarm.us8.list-manage.com/subscribe/post-json',
        actionArgs: {
            u: 'b9be869da00edc9aea7b4049c',
            id: 'd5e3b66e82',
//            ht: 'bebf9e1a2cac40ddefb74ba194d4230a28a9b8d1:MTcxMTM5MDA2My41NTcx',
//            mc_signupsource: 'hosted',
            submit: 'Subscribe',
        },

    }),
    methods: {
        submit() {
            if ( this.submitting ) return;
            this.submitting = true;
            var pid = 0;
            var field;
            this.info = {}
            // Iterate over the forms and collect the values into a single form.
            for(pid = 2; pid <6; pid++) {
                
                this.form[pid].forEach(function (item) {
                    Object.keys(item).forEach(function(key) {
                        if ( item[key].type ) {
                            field = "MERGE" + item[key].fn;
                            var val = this.values[pid][ key ];
                            // Don't transmit empty/undefined fields. For Single
                            // applicants the partner page (3) is skipped, leaving
                            // its values undefined; sending the partner date as
                            // "undefined" makes Mailchimp reject the whole request
                            // with "Please enter the date".
                            if ( val === undefined || val === '' ) return;
                            this.info[ field ] = val;
                            console.log("Tour::submeit: " + field + ": " + this.info[ field ]);
                        }
                    },this)
                }, this)
            }

            this.info['SOURCE'] = this.source;

            Object.keys(this.actionArgs)
                .forEach(key => { this.info[key] = this.actionArgs[key] })
            console.log("[Tour::submit form]: " + JSON.stringify(this.info));

            jsonp(this.action,{ parameters: this.info, callbackParameter: 'c' })
                .then((response) => {
                    console.log("Server said: " + response.result)
                    console.log("Server msg : " + response.msg)
                    this.submitting = false;
                    if(response.result == 'error') {
                        // Stay on the form so the request isn't silently lost.
                        alert(response.msg)
                    } else {
                        this.page = 6
                    }
                })
                .catch((error) => {
                    console.log(error);
                    this.submitting = false;
                    alert("The Interwebs are not happy: " + error + ".  Sorry about that, call us!")
                });

        },
        nextLabel() {
            return ( this.page == 5 ? 'Submit' : 'Next' )
        },
        validate () {
            console.log("[Tour::validate pg ]: " + ( this.page - 1 ) )
            console.log("[Tour::validate ret]: " + this.$refs.national[this.page - 1].validate() )
            // this.$refs.form.validate()
        },
        nextPage() {
            if ( this.page == 1.5 ) this.page = 1;
            if ( this.page == 5 ) { this.submit(); return; }
            if ( this.page == 2 && this.values[2]['STATUS'] == 'Single' ) {
                // this.form['4'].push( { note: { note: 'Please note that we already have alot of people on the waiting list so it might be a while before you hear from us.'}} );
                this.page = 4
            } else {
                this.page++;
            }
            console.log("[Tour::next]: " + this.page)
        },
        previousPage() {
            this.page--;
        },
        getType(field) {
            if (field.type in this.texttypes) return true
            return false
        },
        getSize(field) {
            var size = field.size || 12
            if(/xs|sm/.test(this.$vuetify.breakpoint.name)) {
                size = size * 2
            }
            return size
        },
    },
    mounted() {
        this.page = this.$route.query.page || 1;
        if ( this.page == 1.5 ) { 
            this.logo = this.festival 
            this.source = "Festival"
            this.title = "Festival Invitation Request / Membership Request"
        }
        this.$watch(
            () => this.$route.query,
            (toParams, previousParams) => {
                this.page = this.$route.query.page
                console.log("[Feature]: change: " + previousParams.dir + ' -> ' + toParams.dir)
            }
        )          
    }

}
</script>
